import React from "react";
import MainMenu from "../components/navigations/MainMenu";

export const StudentCard = () => {
  return (
    <div>
      <h1>Student Card</h1>
    </div>
  );
};

const Student = () => {
  return (
    <div className="relative">
      <div className="absolute top-0 left-0">
        <MainMenu bg="gray-900" />
      </div>
      <div className="py-36 overflow-x-scroll">
        <table className="table-auto shadow-lg bg-white border max-w-7xl mx-auto">
          <thead className="border">
            <tr className="p-3">
              <th className="bg-blue-100 border border-gray-300 text-left px-8 py-4">
                Sl. No
              </th>
              <th className="bg-blue-100 border border-gray-300 text-left px-8 py-4">
                Class
              </th>
              <th className="bg-blue-100 border border-gray-300 text-left px-8 py-4">
                No. of Boys
              </th>
              <th className="bg-blue-100 border border-gray-300 text-left px-8 py-4">
                No. of Girls
              </th>
              <th className="bg-blue-100 border border-gray-300 text-left px-8 py-4">
                Total
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border text-left px-8 py-4">1</td>
              <td className="border text-left px-8 py-4">I</td>
              <td className="border text-left px-8 py-4">9</td>
              <td className="border text-left px-8 py-4">6</td>
              <td className="border text-left px-8 py-4">15</td>
            </tr>
            <tr>
              <td className="bg-blue-50 border text-left px-8 py-4">2</td>
              <td className="bg-blue-50 border text-left px-8 py-4">II</td>
              <td className="bg-blue-50 border text-left px-8 py-4">10</td>
              <td className="bg-blue-50 border text-left px-8 py-4">7</td>
              <td className="bg-blue-50 border text-left px-8 py-4">17</td>
            </tr>
            <tr>
              <td className="border text-left px-8 py-4">3</td>
              <td className="border text-left px-8 py-4">III</td>
              <td className="border text-left px-8 py-4">10</td>
              <td className="border text-left px-8 py-4">10</td>
              <td className="border text-left px-8 py-4">20</td>
            </tr>
            <tr>
              <td className="bg-blue-50 border text-left px-8 py-4">4</td>
              <td className="bg-blue-50 border text-left px-8 py-4">IV</td>
              <td className="bg-blue-50 border text-left px-8 py-4">16</td>
              <td className="bg-blue-50 border text-left px-8 py-4">13</td>
              <td className="bg-blue-50 border text-left px-8 py-4">29</td>
            </tr>
            <tr>
              <td className="border text-left px-8 py-4">5</td>
              <td className="border text-left px-8 py-4">V</td>
              <td className="border text-left px-8 py-4">15</td>
              <td className="border text-left px-8 py-4">17</td>
              <td className="border text-left px-8 py-4">32</td>
            </tr>
            <tr>
              <td className="bg-blue-50 border text-left px-8 py-4">6</td>
              <td className="bg-blue-50 border text-left px-8 py-4">VI</td>
              <td className="bg-blue-50 border text-left px-8 py-4">19</td>
              <td className="bg-blue-50 border text-left px-8 py-4">15</td>
              <td className="bg-blue-50 border text-left px-8 py-4">34</td>
            </tr>
            <tr>
              <td className="border text-left px-8 py-4">7</td>
              <td className="border text-left px-8 py-4">VII</td>
              <td className="border text-left px-8 py-4">35</td>
              <td className="border text-left px-8 py-4">27</td>
              <td className="border text-left px-8 py-4">62</td>
            </tr>
            <tr>
              <td className="bg-blue-50 border text-left px-8 py-4">8</td>
              <td className="bg-blue-50 border text-left px-8 py-4">VIII</td>
              <td className="bg-blue-50 border text-left px-8 py-4">30</td>
              <td className="bg-blue-50 border text-left px-8 py-4">23</td>
              <td className="bg-blue-50 border text-left px-8 py-4">53</td>
            </tr>
            <tr>
              <td className="border text-left px-8 py-4">9</td>
              <td className="border text-left px-8 py-4">IX</td>
              <td className="border text-left px-8 py-4">49</td>
              <td className="border text-left px-8 py-4">47</td>
              <td className="border text-left px-8 py-4">96</td>
            </tr>
            <tr>
              <td className="bg-blue-50 border text-left px-8 py-4">10</td>
              <td className="bg-blue-50 border text-left px-8 py-4">X</td>
              <td className="bg-blue-50 border text-left px-8 py-4">54</td>
              <td className="bg-blue-50 border text-left px-8 py-4">56</td>
              <td className="bg-blue-50 border text-left px-8 py-4">110</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Student;
